import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WhiteboardService {
  private boardEventSource = new Subject<any>();
  boardEvent$ = this.boardEventSource.asObservable();

  passBoardEvent(event: any) {
    this.boardEventSource.next(event);
  }
}
